import ManagePod from "../components/ManagePod";

export default function Fleets() {
  return (
      <ManagePod />
  );
}